import { render, staticRenderFns } from "./djyl_bztb_detail.vue?vue&type=template&id=a218757c&scoped=true"
import script from "./djyl_bztb_detail.vue?vue&type=script&lang=js"
export * from "./djyl_bztb_detail.vue?vue&type=script&lang=js"
import style0 from "./djyl_bztb_detail.vue?vue&type=style&index=0&id=a218757c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a218757c",
  null
  
)

export default component.exports